import React from 'react';
import { List, Divider, Tag, Image, Button, Input } from 'antd';
import { SendOutlined, PaperClipOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { TextArea } = Input;

const estadoColor  = { abierto: 'blue', en_proceso: 'orange', resuelto: 'green', cerrado: 'default' };
const prioridadColor = { baja: 'default', normal: 'blue', alta: 'orange', urgente: 'red' };

const TicketHilo = ({
  ticket,
  mensajeText,
  onMensajeChange,
  onEnviar,
  enviando = false,
  readOnly = false,
}) => {
  if (!ticket) return null;

  return (
    <>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
        <Tag color={estadoColor[ticket.estado] || 'default'}>{ticket.estado}</Tag>
        <Tag color={prioridadColor[ticket.prioridad] || 'blue'}>
          Prioridad: {ticket.prioridad || 'normal'}
        </Tag>
        {ticket.destinatario_tipo === 'puja' && (
          <Tag color="purple">Soporte Puja</Tag>
        )}
      </div>

      {ticket.descripcion && (
        <p style={{ color: '#666', marginBottom: 12 }}>{ticket.descripcion}</p>
      )}

      {ticket.imagenes?.length > 0 && (
        <>
          <Divider orientation="left" plain style={{ fontSize: 12, color: '#999' }}>
            <PaperClipOutlined /> Imágenes adjuntas
          </Divider>
          <Image.PreviewGroup>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
              {ticket.imagenes.map((img) => (
                <Image
                  key={img.id_imagen}
                  src={img.url_imagen}
                  width={80}
                  height={80}
                  style={{ objectFit: 'cover', borderRadius: 4 }}
                />
              ))}
            </div>
          </Image.PreviewGroup>
        </>
      )}

      <Divider />

      <List
        dataSource={ticket.mensajes || []}
        locale={{ emptyText: 'Sin mensajes aún' }}
        renderItem={(m) => (
          <List.Item>
            <List.Item.Meta
              title={m.usuario?.nom_usuario || 'Usuario'}
              description={m.mensaje}
            />
            <span style={{ color: '#999', fontSize: 12, whiteSpace: 'nowrap', marginLeft: 8 }}>
              {dayjs(m.created_at).format('DD/MM/YYYY HH:mm')}
            </span>
          </List.Item>
        )}
      />

      {!readOnly && ticket.estado !== 'resuelto' && ticket.estado !== 'cerrado' && (
        <>
          <Divider />
          <TextArea
            rows={3}
            value={mensajeText}
            onChange={(e) => onMensajeChange(e.target.value)}
            placeholder="Escribí tu respuesta..."
          />
          <Button
            type="primary"
            icon={<SendOutlined />}
            loading={enviando}
            onClick={onEnviar}
            style={{ marginTop: 8 }}
          >
            Enviar
          </Button>
        </>
      )}
    </>
  );
};

export default TicketHilo;
